import { useEffect } from 'react';

export const LivePageStateSync = ({
	contentId,
	isLive,
	onChange,
}: {
	contentId: string;
	isLive: boolean;
	onChange: (isLive: boolean) => void;
}) => {
	// A concurrent render can be restarted or abandoned. Only publish the state of
	// committed content to the external store, otherwise its subscribers restart rendering.
	useEffect(() => {
		onChange(isLive);
	}, [contentId, isLive, onChange]);

	return null;
};
